import * as AddPersonalNutritionItemsFailed from '@ori-events/add-personal-nutrition-items-failed';
import { HttpMethod } from '@ori/checkout-utils';
import { addPersonalNutritionItems } from '../api';
import { mainLogger } from '../logger';
import { RequestUrl } from '../types';
import { convertToCamelCase, getHttpRequestSettings } from '../utils';
export async function addPersonalNutritionItemsHandler({
  detail: {
    items
  }
}, {
  client,
  sessionId,
  tenant
}) {
  const globalShoppingPersonalNutritionComponentsDto = {
    collection: items
  };
  try {
    await addPersonalNutritionItems({
      client,
      globalShoppingPersonalNutritionComponentsDto,
      sessionId,
      tenant
    });
  } catch (error) {
    mainLogger.error(error, {
      message: 'Error while adding personal nutrition items in addPersonalNutritionItems event'
    });
    const errorEvent = new CustomEvent(AddPersonalNutritionItemsFailed.Name, {
      detail: {
        isSuccess: false,
        localizedMessage: String(error),
        message: String(error)
      }
    });
    window.dispatchEvent(errorEvent);
    return false;
  }

  // STEP 2 - Update shopping context via Online endpoint
  const response = await fetch(RequestUrl.GetShoppingContext, getHttpRequestSettings(undefined, HttpMethod.Post));
  const rawData = convertToCamelCase(await response.json());
  if (AddPersonalNutritionItemsFailed.isAddPersonalNutritionItemsErrorResponse(rawData)) {
    const errorEvent = new CustomEvent(AddPersonalNutritionItemsFailed.Name, {
      detail: rawData
    });
    window.dispatchEvent(errorEvent);
    return false;
  }
  const data = {
    ...rawData,
    isPersonalNutritionAddedAsLast: true
  };
  return data;
}
//# sourceMappingURL=addPersonalNutritionItemsHandler.js.map